<template>
  <v-container fluid class="role-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/role/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn 
                v-show="item_seleted.length>0"
                :loading="isLoading"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
                @click="copyRole"
              >
                <v-icon class="mr-2">mdi-content-copy</v-icon>
                Copy
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="item_seleted"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="roles-table"
              show-select
              single-select
              item-key="_id"
              sort-by="rolename"
              :footer-props="footer"
              :headers="roleHeaders"
              :items="roles"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteRole"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Role?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_role.rolename }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteRole = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteRole(delete_role)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.roleimage" size="35">
                  <img v-bind:src="item.roleimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.rolename[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.rolename="{ item }">
                <a class="primaryConst--text">{{ item.rolename }}</a>
              </template>
              <template v-slot:item.roleemail="{ item }">
                <a class="primaryConst--text">{{ item.roleemail }}</a>
              </template>
              <template v-slot:item.roleid="{ item }">
                {{ item.roleid }}
              </template>
              <template v-slot:item.rolestatus="{ item }">
                <v-row>
                <v-chip
                  :color="item.rolestatus=='Active' ? 'success white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.rolestatus }}
                </v-chip>
                </v-row>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editRole(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteRoleDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'RoleList',
  data() {
    return {
      isDeleteRole: false,
      isLoading: false, 
      delete_role: {},
      item_seleted: [],
      roleHeaders: [
        { text: 'Name', value: 'rolename' },
        { text: 'Code', value: 'rolecode' },
        { text: 'Type', value: 'roletype' },
        { text: 'Status', value: 'rolestatus' },
        { text: 'Create', value: 'createdAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
    }
  },

  computed: {
    ...mapState('Role', ['roles', 'isReceiving', 'isDeleting', 'idToDelete', 'rolesMessage', 'isUpdating']),
  },
  mounted () {
    this.getRolesRequest();
  },
  methods: {
    ...mapActions('Role', ["getRolesRequest","deleteRoleRequest","copyRoleRequest","createRoleRequest"]),
    async copyRole(){
      this.isLoading = true;
      if(this.item_seleted==null  || this.item_seleted.length==0) return;
      let selected = this.item_seleted[0];
      await this.copyRoleRequest(selected);
      this.isLoading = false;
      this.item_seleted = [];
    },
    editRole(item) {
      this.$router.push({ name: 'RoleEdit', params: item });
    },
    deleteRole(item) {
      this.deleteRoleRequest({_id: item._id});
      this.isDeleteRole = false;
    },
    deleteRoleDialog(item) {
      this.isDeleteRole = true;
      this.delete_role = {_id: item._id, rolename: item.rolename}
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
